<template>
  <vs-popup id="mass-balance-table" class="mass-balance-detail-view-popup"
    :title="`Mass Balance Details ( ${popupData.row.raw_material_code || ''} ) ( ${popupData.row.batch_code || ''} )`" :active.sync="open" :buttons-hidden="true"
    @close="closePopup">
    <vx-card no-shadow>
      <div v-if="popupData">
        <h4 class="mb-4">RM MASS BALANCE</h4>

        <ol class="list-decimal pl-8 space-y-2 mb-8" style="list-style-type: decimal;">
          <li class="text-danger">BATCH QUANTITY RECEIVED (KG):
            {{ popupData.row.total_quantity | remove_trailing_zeros }}
            <ol class="list-decimal pl-8 mt-2 space-y-2" style="list-style-type: decimal;">
              <li>QC PENDING (KG): {{ popupData.row.pending_q_c_test_qty | remove_trailing_zeros }} </li>
              <li>QC FAILED (KG): {{ popupData.row.rejected_stock | remove_trailing_zeros }}</li>
              <li>QC PASSED RELEASED TO STOCK (KG): {{ popupData.row.approved_quantity | remove_trailing_zeros }}</li>
            </ol>
          </li>
          <li style="color: cornflowerblue">RM LIVE STOCK (KG):
            {{ popupData.row.available_quantity | remove_trailing_zeros }}</li>
          <li style="color: cornflowerblue">USED IN WO (KG):
            {{ popupData.row.overall_work_order_qty | remove_trailing_zeros }}</li>
          <li style="color: cornflowerblue">SUNDRIED TO NPD OR WASTE (KG):
            {{ popupData.row.overall_waste_qty | remove_trailing_zeros }}</li>


          <li class="text-primary font-bold" style="margin-top: 15px !important;">MASS BALANCE (KG):
            {{ popupData.row.quantity_discrepancy | remove_trailing_zeros }}
          </li>
        </ol>
      </div>

      <vs-table v-if="work_orders.length > 0" class="mt-8" :data="work_orders" stripe>
        <template slot="header">
          <h5 class="mb-4 text-warning">WORK ORDERS</h5>
        </template>

        <template slot="thead">
          <vs-th>WO CODE</vs-th>
          <vs-th>FG CODE</vs-th>
          <vs-th>WO DATE</vs-th>
          <vs-th>QUANTITY USED IN WO (KG)</vs-th>
          <vs-th>QC STATUS</vs-th>
          <vs-th>WO STATUS</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(tr_item, index_item) in data" :key="index_item">
            <vs-td>
              {{ tr_item.work_order_code }}
            </vs-td>

            <vs-td>
              {{ tr_item.formulation.formulation_code }}
            </vs-td>

            <vs-td>
              {{ tr_item.work_order_date }}
            </vs-td>

            <vs-td>
              {{ tr_item.quantity_used_in_wo }}
            </vs-td>

            <vs-td>
              {{ tr_item.q_c_status || "N/A" }}
            </vs-td>

            <vs-td>
              {{ tr_item.status }}
            </vs-td>
            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full px-8">
                <vs-table v-if="tr_item.stock.length > 0" class="my-8" hoverFlat id="wo_stock_item_table"
                  :data="tr_item.stock" stripe>
                  <template slot="header">
                    <h5 class="mb-4 text-danger">FG STOCK</h5>
                  </template>
                  <template slot="thead">
                    <vs-th>MADE FOR</vs-th>
                    <vs-th>MANUFACTURE DATE</vs-th>
                    <vs-th>PRODUCT ORDER CODE</vs-th>
                    <vs-th>CUSTOMER NAME</vs-th>
                    <vs-th>QUANTITY (KG)</vs-th>
                    <vs-th>STOCK ITEM STATUS</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index_item_wo_stock" v-for="(tr_wo_stock_item, index_item_wo_stock) in data">
                      <vs-td>
                        {{ tr_wo_stock_item.made_for }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_stock_item.manufacture_date }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_stock_item.product_order_code }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_stock_item.customer_name }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_stock_item.rm_quantity || "N/A" }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_stock_item.item_status || "N/A" }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <vs-table v-if="tr_item.waste.length > 0" class="my-8" hoverFlat id="wo_waste_table"
                  :data="tr_item.waste" stripe>
                  <template slot="header">
                    <h5 class="mb-4 text-danger">FG WASTE ITEMS</h5>
                  </template>
                  <template slot="thead">
                    <vs-th>QUANTITY (KG)</vs-th>
                    <vs-th>WASTE STATUS</vs-th>
                    <vs-th>DISPOSE NOTE</vs-th>
                    <vs-th>DISPOSED AT</vs-th>
                    <vs-th>DISPOSED BY</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index_item_wo_waste" v-for="(tr_wo_order_waste, index_item_wo_waste) in data">
                      <vs-td>
                        {{ tr_wo_order_waste.rm_quantity }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_waste.status }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_waste.dispose_note }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_waste.dispose_timestamp }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_waste.disposed_by_staff }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <vs-table v-if="tr_item.shipments.length > 0" class="my-8" hoverFlat id="wo_shipment_table"
                  :data="tr_item.shipments" stripe>
                  <template slot="header">
                    <h5 class="mb-4 text-danger">SHIPMENTS</h5>
                  </template>
                  <template slot="thead">
                    <vs-th>SHIPMENT CODE</vs-th>
                    <vs-th>DATE OF BOOKING</vs-th>
                    <vs-th>ESTIMATE DELIVERY DATE</vs-th>
                    <vs-th>SHIPMENT STATUS</vs-th>
                    <vs-th>SHIPMENT ITEMS COUNT</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index_item_wo_shipment" v-for="(
                          tr_wo_order_shipment, index_item_wo_shipment
                        ) in data">
                      <vs-td>
                        {{ tr_wo_order_shipment.courier_shipment_code }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_shipment.date_of_booking }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_shipment.estimated_delivery_date }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_shipment.status }}
                      </vs-td>
                      <vs-td>
                        {{ tr_wo_order_shipment.items.length }}
                      </vs-td>
                      <template class="expand-user" slot="expand">
                        <div class="con-expand-users w-full px-8">
                          <span v-for="(
                                tr_wo_order_shipment_item,
      index_item_wo_shipment_item
                              ) in tr_wo_order_shipment.items" :key="index_item_wo_shipment_item">
                            {{ index_item_wo_shipment_item + 1 }} ) Order
                            Code: {{ tr_wo_order_shipment_item.order_code }}
                            <br />
                            Shipment Quantity(KG):
                            {{ tr_wo_order_shipment_item.rm_quantity }}
                          </span>
                        </div>
                      </template>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination v-if="work_orders.length" v-on:changeMaxItems="changeWoPerPage" :size-array="woMeta.total ? woMeta.total : 20"
        :max-items="woPerPage" description-body="Rows per page" description-connector="of" description-title="Records"
        description :description-items="descriptionItems" :total="woMeta.last_page ? woMeta.last_page : 0"
        v-model="woPage" class="p-5" />


      <vs-table v-if="waste_items.length > 0" class="mt-8" :data="waste_items" stripe>
        <template slot="header">
          <h5 class="mb-4 text-warning">WASTE</h5>
        </template>

        <template slot="thead">
          <vs-th>CREATED DATE</vs-th>
          <vs-th>QUANTITY (KG)</vs-th>
          <vs-th>STATUS</vs-th>
          <vs-th>DISPOSE NOTE</vs-th>
          <vs-th>DISPOSED BY</vs-th>
          <vs-th>DISPOSED AT</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, index) in data" :key="index">
            <vs-td>
              {{ __dateTimeFormatter(item.created_at) }}
            </vs-td>
            <vs-td>
              {{ item.quantity }}
            </vs-td>
            <vs-td>
              {{ item.status }}
            </vs-td>
            <vs-td>
              {{ item.dispose_note || "N/A" }}
            </vs-td>
            <vs-td>
              {{ item.disposed_by_staff || "N/A" }}
            </vs-td>
            <vs-td>
              {{ item.dispose_timestamp || 'N/A' }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination v-if="waste_items.length" v-on:changeMaxItems="changeWastePerPage"
        :size-array="wasteMeta.total ? wasteMeta.total : 20" :max-items="wastePerPage" description-body="Rows per page"
        description-connector="of" description-title="Records" description :description-items="descriptionItems"
        :total="wasteMeta.last_page ? wasteMeta.last_page : 0" v-model="wastePage" class="p-5" />
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: "RMMassBalanceDetailViewPopUp",

  data() {
    return {
      open: false,
      popupData: null,
      inventory_id: null,

      work_orders: [],
      waste_items: [],

      // WO pagination
      woPage: 1,
      woPerPage: defaultPagination,
      woMeta: {},

      // Waste pagination
      wastePage: 1,
      wastePerPage: defaultPagination,
      wasteMeta: {},

      descriptionItems: perPageList,

    };
  },

  methods: {
    async openPopup(data, inventory_id) {
      this.popupData = data;
      this.inventory_id = inventory_id
      this.open = true;
      this.woPage = 1
      this.wastePage = 1
      await this.fetchWoData()
      await this.fetchWasteData()
    },

    closePopup() {
      this.open = false;
    },
    async fetchWoData() {
      try {
        const { data } = (await ReportingRepository.getMassBalanceWorkOrderData(
          this.inventory_id,
          this.woPage,
          this.woPerPage
        ))
        this.work_orders = data.data;
        this.woMeta = data.meta;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchWasteData() {
      try {
        const { data } = (await ReportingRepository.getMassBalanceWasteData(
          this.inventory_id,
          this.wastePage,
          this.wastePerPage
        ))
        this.waste_items = data.data;
        this.wasteMeta = data.meta;
      } catch (error) {
        console.error(error);
      }
    },
    handleWoPage(page) {
      this.woPage = page;
    },
    handleWastePage(page) {
      this.wastePage = page;
    },
    changeWoPerPage(index) {
      this.woPerPage = this.descriptionItems[index];
    },
    changeWastePerPage(index) {
      this.wastePerPage = this.descriptionItems[index];
    },
  },
  watch: {
    woPage() {
      this.fetchWoData();
    },

    woPerPage() {
      this.woPage = 1;
      this.fetchWoData();
    },

    wastePage() {
      this.fetchWasteData();
    },

    wastePerPage() {
      this.wastePage = 1;
      this.fetchWasteData();
    }
  }
};
</script>
<style scoped>
.mass-balance-detail-view-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 80% !important;
}

ol {
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
}

ol>li {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
}

ol>li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
  padding-right: 0.6em;
}

li ol>li {
  margin: 0;
}

li ol>li:before {
  content: counters(item, ".") " ";
}
</style>
